import { render, staticRenderFns } from "./MarketplaceDescriptiveForm.vue?vue&type=template&id=bb53f428&scoped=true&"
import script from "./MarketplaceDescriptiveForm.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDescriptiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb53f428",
  null
  
)

export default component.exports